/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/

class AdvancedAccordion extends HTMLElement {
  constructor() {
    super();

    this.collapses = this.querySelectorAll('collapse-component');
    this.openedCollapse = this.dataset.openFirst === 'true' ? 0 : null;

    this.handleAccordion()
  }

  handleAccordion() {
    this.collapses.forEach((collapse) => {
      collapse.addEventListener('collapse:open', () => {
        if (this.openedCollapse !== null && this.openedCollapse !== collapse.dataset.index) {
          console.log(this.openedCollapse)
          this.collapses[this.openedCollapse].close();
        }
        this.openedCollapse = collapse.dataset.index;

        this.handleSlider();
      });
    });
  }

  handleSlider() {
    this.querySelectorAll('.advanced-accordion-img-slide').forEach((slide, index) => {
      if (index == this.openedCollapse) {
        slide.classList.add('active');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.classList.remove('active');
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }
}
customElements.define('advanced-accordion', AdvancedAccordion);